import { AppointmentContainer } from "@/components/layout/AppointmentContainer";
import { AppointmentInfo } from "@/features/appointments/AppointmentInfo";
import {
  getColor,
  getIsDashed,
  getRenderTypeInfo,
} from "@/features/calendar/utils";
import { useModals } from "@/features/modals/hooks";
import styled from "@emotion/styled";
import { type ExtendedAppointment } from "@repo/api";
import { Variables } from "@repo/skapa";
import { Line, useSettings } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

const Container = styled.li<{ first?: boolean; noLine?: boolean }>`
  display: flex;
  flex-direction: column;

  padding-top: ${({ first, noLine }) =>
    first || noLine ? "0" : Variables.space150};
  gap: ${Variables.space150};
`;

const ContentContainer = styled.div`
  padding: 0 ${Variables.space150} ${Variables.space75} ${Variables.space150};
`;

export const UpcomingAppointmentItem = ({
  editable,
  appointment,
  first,
  last,
  noLine,
  projectId,
}: {
  editable?: boolean;
  appointment: ExtendedAppointment;
  first?: boolean;
  last?: boolean;
  noLine?: boolean;
  projectId?: number;
}) => {
  const { task_configuration, calendar } = useSettings();
  const { pushModal } = useModals();

  const openDetailModal = (showActions: boolean) =>
    pushModal({
      type: "APPOINTMENT",
      appointment,
      showActions,
      projectId,
    });
  const typeInfo = getRenderTypeInfo(appointment);
  const colorInfo = getColor(
    typeInfo,
    task_configuration?.task_types,
    calendar?.activity_configuration
  );

  return (
    <Container first={first} noLine={noLine}>
      <AppointmentContainer
        onClick={
          editable
            ? () => {
                openDetailModal(false);
                trackAnalytics("open_details_modal");
              }
            : undefined
        }
        backgroundColor={colorInfo.color}
        borderColor={colorInfo.borderColor}
        dashed={getIsDashed(typeInfo)}
        selected={false}
      >
        <ContentContainer>
          <AppointmentInfo
            appointment={appointment}
            onClickMoreActions={() => openDetailModal(true)}
            variant="MANAGE"
            editable={editable}
          />
        </ContentContainer>
      </AppointmentContainer>
      {!last && !noLine && <Line />}
    </Container>
  );
};
